(function() {
  'use strict';

  // Проверяем что конфиг попапа загружен
  if (!window.popupConfig || !window.popupConfig.enabled) {
    console.log('Popup disabled via metafields');
    return;
  }

  // Проверка на checkout/thank you pages
  const currentPath = window.location.pathname;
  if (currentPath.includes('/checkout') || 
      currentPath.includes('/thank-you') ||
      currentPath.includes('/thank_you') ||
      currentPath.includes('/orders/') ||
      currentPath.includes('/account')) {
    console.log('Popup disabled on checkout/account/thank you pages');
    return;
  }




  // Константы из конфига
  const config = window.popupConfig;
  const delayMs = config.delay * 1000;
  const reshowDays = config.reshowDays;
  const reshowMs = reshowDays * 24 * 60 * 60 * 1000;

  // Проверяем localStorage
  const STORAGE_KEY = 'promoPopupState';
  const popupState = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  const now = Date.now();

  // Проверка заказов клиента - ТОЛЬКО если включена настройка onlyNewCustomers
  if (config.onlyNewCustomers && window.customerHasOrders) {
    console.log('Popup disabled: customer has orders (onlyNewCustomers mode enabled)');
    return;
  }
  
  // Логируем режим таргетинга
  if (config.onlyNewCustomers) {
    console.log('Popup targeting: NEW customers only (no order history)');
  } else {
    console.log('Popup targeting: ALL visitors');
  }
  // Проверка использования промокода
  if (popupState.promoUsed || sessionStorage.getItem('promoUsed')) {
    console.log('Popup disabled: promo code used');
    return;
  }

  // Проверка повторного показа через N дней
  if (popupState.closed && popupState.closedAt) {
    const timeSinceClosed = now - popupState.closedAt;
    if (timeSinceClosed < reshowMs) {
      const daysLeft = Math.ceil((reshowMs - timeSinceClosed) / (24 * 60 * 60 * 1000));
      console.log(`Popup will reshow in ${daysLeft} days`);
      return;
    }
  }

  // Функция показа попапа
  function showPopup() {
    const popup = document.getElementById('promo-popup');
    if (!popup) {
      console.error('Popup element not found');
      return;
    }

    // Заполняем контент
    document.getElementById('popup-title').textContent = config.title || 'Promoție specială!';
    document.getElementById('popup-text').textContent = config.text || 'Obține reducere la prima ta comandă!';
    document.getElementById('popup-code').textContent = config.discountCode || 'WELCOME10';
    document.getElementById('promo-popup_button').textContent = config.buttonText || 'PROFITĂ DE OFERTĂ';
    document.getElementById('popup-text-after').textContent = config.textAfter || 'Folosește codul la finalizarea comenzii';
    
    

    // Показываем попап
    popup.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    // Сохраняем что показали
    const newState = {
      shown: true,
      shownAt: now,
      closed: false
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newState));

    console.log('Popup shown');
  }

  // Функция закрытия попапа
  function closePopup() {
    const popup = document.getElementById('promo-popup');
    popup.style.display = 'none';
    document.body.style.overflow = '';

    // Сохраняем что закрыли
    const currentState = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    currentState.closed = true;
    currentState.closedAt = Date.now();
    localStorage.setItem(STORAGE_KEY, JSON.stringify(currentState));

    console.log(`Popup closed. Will reshow in ${reshowDays} days`);
  }

  // Функция копирования промокода
  function copyCode() {
    const code = document.getElementById('popup-code').textContent;
    const button = document.getElementById('copy-code');
    
    navigator.clipboard.writeText(code).then(() => {
      const originalText = button.textContent;
      button.textContent = '✓ Copiat!';
      button.style.background = '#10b981';
      
      setTimeout(() => {
        button.textContent = originalText;
        button.style.background = '';
      }, 2000);
    }).catch(err => {
      console.error('Failed to copy:', err);
      // Fallback для старых браузеров
      const textArea = document.createElement('textarea');
      textArea.value = code;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      button.textContent = '✓ Copiat!';
    });
  }

  // Инициализация после загрузки DOM
  function init() {
    // Добавляем обработчики событий
    const closeBtn = document.querySelector('.promo-popup__close');
    const overlay = document.querySelector('.promo-popup__overlay');
    const copyBtn = document.getElementById('copy-code');
    const ctaBtn = document.querySelector('.promo-popup__cta');

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (overlay) overlay.addEventListener('click', closePopup);
    if (copyBtn) copyBtn.addEventListener('click', copyCode);
    
    // CTA кнопка закрывает попап
    if (ctaBtn) {
      ctaBtn.addEventListener('click', () => {
        closePopup();
        // window.location.href = '/collections/all';
      });
    }

    // ESC закрывает попап
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const popup = document.getElementById('promo-popup');
        if (popup && popup.style.display === 'flex') {
          closePopup();
        }
      }
    });

    // Показываем попап с задержкой
    console.log(`Popup will show in ${config.delay} seconds`);
    setTimeout(showPopup, delayMs);
  }

  // Запуск после загрузки DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
